import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Label, Input, FormText } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Field } from "formik";
import deletenew from "../../assets/images/deletenew.svg";
import { act } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSlotsTypes } from "../../redux/actions/api/apiAction";
import { types } from "babel-core";
import MultiSelector from "../multiSelector";

const TypeScheduleTabs = ({
  formikProps,
  gym,
  courtSchedulingFillingType,
  setCourtSchedulingFillingType,
  setFieldValue,
  values,
  setDeleteTimeState,
  deleteTimeState,
  setChanger,
  changer,
  tempTimeStateObject,
  setTempTimeStateObject,
  timesArr,
  setCheckedDays,
  weekDays,
  activeType,
  setActiveType,
  dayTimeStateByType,
  setDayTimeStateByType,
  setCurrentInterval,
  checkedDaysByType,
  setAllDaysCheckedByType,
  allDaysCheckedByType,
  setCheckedDaysByType,
  resetDaysAndTimes,
  currentUpdatedInterval,
  durationsList,
  durationsSelected,
  setStepMinutes,
  stepMinutes,
  edit,
  setDeletedSlots
}) => {
  // Get types based on gym type
  const dispatch = useDispatch();

  const { slotsTypes } = useSelector((state) => state.court);
  const getTypes = async () => {
    return gym.type == "complex" && (await dispatch(getSlotsTypes()));
  };

  useEffect(() => {
    if (!activeType && slotsTypes.length > 0) {
      setActiveType(slotsTypes[0]?.id);
    }

    let checkedDaysType = {};
    let times = {};
    for (let i = 0; i < slotsTypes.length; i++) {
      let type = slotsTypes[i]?.id;
      checkedDaysType = {
        ...checkedDaysType,
        [type]: {
          Saturday: false,
          Sunday: false,
          Monday: false,
          Tuesday: false,
          Wednesday: false,
          Thursday: false,
          Friday: false,
        },
      };
      times = {
        ...times,
        [type]: {
          Saturday: [],
          Sunday: [],
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        },
      };

      setAllDaysCheckedByType({ ...allDaysCheckedByType, [type]: false });
    }
    setCheckedDaysByType(checkedDaysType);
    setDayTimeStateByType(times);
  }, [slotsTypes]);
  // First effect - only runs when slotsTypes changes

  // Second effect - only runs when currentUpdatedInterval changes
  useEffect(() => {
    if (currentUpdatedInterval?.timeSlotsByType) {
      let activeType = Object.keys(currentUpdatedInterval?.timeSlotsByType);
      setActiveType(parseInt(activeType[0]));

      // Create a completely new object
      const newCheckedDaysByType = {};
      const newTime = {};

      // First, copy the existing structure from your current state
      // This ensures we maintain the structure for all types
      slotsTypes.forEach((slot) => {
        const type = slot?.id;
        newCheckedDaysByType[type] = {
          Saturday: false,
          Sunday: false,
          Monday: false,
          Tuesday: false,
          Wednesday: false,
          Thursday: false,
          Friday: false,
        };
        newTime[type] = {
          Saturday: [],
          Sunday: [],
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        };
      });

      // Then apply the updates from currentUpdatedInterval
      Object.keys(currentUpdatedInterval?.timeSlotsByType).forEach((type) => {
        const checkedDays = currentUpdatedInterval?.timeSlotsByType[type];

        Object.keys(checkedDays).forEach((day) => {
          const values = checkedDays[day];
          if (values.length) {
            newCheckedDaysByType[type][day] = true;
            newTime[type][day] = values;
          }
        });
      });

      // Set the completely new object
      // setCheckedDaysByType(newCheckedDaysByType);
      setDayTimeStateByType(newTime);
    }
  }, [currentUpdatedInterval, slotsTypes]);

  useEffect(() => {
    getTypes();
  }, []);
  const resetDayTempCheck=()=>{
    let checkedDaysType = {};
    for (let i = 0; i < slotsTypes.length; i++) {
        let type = slotsTypes[i]?.id;
        checkedDaysType = {
          ...checkedDaysType,
          [type]: {
            Saturday: false,
            Sunday: false,
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
          },
        };
      
        setAllDaysCheckedByType({ ...allDaysCheckedByType, [type]: false });
      }
    setCheckedDaysByType(checkedDaysType);
  }
  const handleAddTimeSlot = () => {
    const { start, end } = tempTimeStateObject;
    if (start === null || end === null || start === "" || end === "") {
      alert("Please select both 'from' and 'to' times.");
      return;
    }
    const startIndex = parseInt(start);
    const endIndex = parseInt(end);
    if (isNaN(startIndex) || isNaN(endIndex)) {
      alert("Please select valid times.");
      return;
    }
    // Direct modification of existing slots
    Object.keys(checkedDaysByType[activeType]).forEach((day) => {
      if (checkedDaysByType[activeType][day]) {
        // Initialize array if doesn't exist
        if (!dayTimeStateByType[activeType][day]) {
          dayTimeStateByType[activeType][day] = [];
        }
        // Add new time slot directly to existing structure
        dayTimeStateByType[activeType][day].push({
          start: timesArr[startIndex].value,
          end: timesArr[endIndex].value,
        });
      }
    });
    setDayTimeStateByType({ ...dayTimeStateByType });
    setCurrentInterval((prev) => ({
      ...prev,
      timeSlots: [],
      timeSlotsByType: dayTimeStateByType,
    }));
    setTempTimeStateObject({ start: null, end: null });
    resetDayTempCheck()
  };
  const generateStartTimeAndEndByIntervalPeriod = () => {
      const { start, end } = tempTimeStateObject;

      if (start === null || end === null || start === "" || end === "") {
        alert("Please select both 'from' and 'to' times.");
        return [];
      }

      const startIndex = parseInt(start, 10);
      const endIndex = parseInt(end, 10);

      const startMoment = moment(timesArr[startIndex].value, "HH:mm");
      const endMoment = moment(timesArr[endIndex].value, "HH:mm");
      if (!startMoment.isValid() || !endMoment.isValid()) {
        alert("Please select valid times.");
        return [];
      }
      if (endIndex <= startIndex) {
        alert("End time must be after start time.");
        return [];
      }

      // The picker is ordered as one operational day (06:00 through 05:50).
      // Early-morning closing times therefore belong to the following day.
      if (!endMoment.isAfter(startMoment)) {
        endMoment.add(1, "day");
      }

      if (!durationsSelected || durationsSelected.length === 0) {
        alert("Please select interval(s)");
        return [];
      }

      // Parse all intervals to integers
      const intervals = durationsSelected.map(i => parseInt(i, 10)).filter(i => !isNaN(i) && i > 0);
      if (intervals.length === 0) {
        alert("Invalid interval(s)");
        return [];
      }

      const slotsByInterval = {};

      intervals.forEach(interval => {
        const slots = [];
        let current = startMoment.clone();
        const step = stepMinutes || interval; // if user didn’t select → step = interval

        while (current.isBefore(endMoment)) {
          const slotStart = current.clone();
          const slotEnd = slotStart.clone().add(interval, "minutes");

          if (slotEnd.isAfter(endMoment)) break;

          slots.push({
            start: slotStart.format("HH:mm"),
            end: slotEnd.format("HH:mm"),
          });

          current.add(step, "minutes");
        }

        slotsByInterval[interval] = slots; // store slots for this interval
      });


      // Optional: if you want to combine all intervals into one array
      const combinedSlots = Object.values(slotsByInterval).flat();


       // Direct modification of existing slots
      Object.keys(checkedDaysByType[activeType]).forEach((day) => {
        if (checkedDaysByType[activeType][day]) {
          if(dayTimeStateByType[activeType][day].length){
            dayTimeStateByType[activeType][day] = [...dayTimeStateByType[activeType][day], ...combinedSlots.map(s => ({ ...s }))];
          } else{
            dayTimeStateByType[activeType][day] = [...combinedSlots.map(s => ({ ...s }))]; // clone
          }
        }
      });
    
    setCurrentInterval((prev) => ({
      ...prev,
      timeSlots: [],
      timeSlotsByType: dayTimeStateByType,
    }));
      setTempTimeStateObject({ start: null, end: null });
      setDayTimeStateByType({ ...dayTimeStateByType });
      setFieldValue("durationsSelected",[])
      setStepMinutes(null)
      setCourtSchedulingFillingType("multipleDays")
      setCurrentInterval(prev => ({
        ...prev,
        timeSlotsByType: dayTimeStateByType,
      }));
     
    resetDayTempCheck()
  };
  const isAddSlotButtonDisabled = () => {
    const { start, end } = tempTimeStateObject;

    // Check if courtSchedulingFillingType is multipleDays
    if (courtSchedulingFillingType !== "multipleDays" && courtSchedulingFillingType !== "timeRange") {
      return true; // Disable the button if not in multipleDays or timeRange mode
    }

    // Check if start or end times are not selected
    if (!start || !end) {
      return true;
    }

    // Check if start or end times are empty strings
    if (start === "" || end === "") {
      return true;
    }

    // Parse start and end as integers
    const startIndex = parseInt(start);
    const endIndex = parseInt(end);

    // Ensure start and end are valid indices
    if (isNaN(startIndex) || isNaN(endIndex)) {
      return true;
    }

    // Check if no day is selected
    if (Object.values(checkedDaysByType[activeType]).every((day) => !day)) {
      return true;
    }

    // If all conditions are satisfied, enable the button
    return false;
  };
  const handleDeleteScheduleTime = () => {
    const { day: deletedDay, timeIndex: time } = deleteTimeState;
    const timesArr = dayTimeStateByType[activeType];
    const deletedSlot = timesArr[deletedDay][time];
    if(deletedSlot){
      timesArr[`${deletedDay}`].splice(time, 1);
      setDayTimeStateByType({ ...dayTimeStateByType });
      setDeletedSlots(prev => [...prev, deletedSlot]);
      setChanger(!changer);
    }
  };
  React.useEffect(() => {
    if (deleteTimeState.day) {
      handleDeleteScheduleTime();
    }
  }, [deleteTimeState]);

  React.useEffect(() => {
    setFieldValue("scheduleDaysByType", dayTimeStateByType);
  }, [dayTimeStateByType]);

  return (
    <div className="type-schedule-tabs">
      {/* Type Tabs */}
      {console.log({ checkedDaysByType })}
      <div className="type-tabs d-flex mb-4 border-bottom">
        {slotsTypes.map((type) => (
          <p
            key={type?.id}
            style={{
              fontSize: 15,
              fontWeight: activeType === type?.id ? "bold" : "normal",
              borderBottom:
                activeType === type?.id ? "2px solid #FFA500" : "none",
              color: "#4d4467",
              cursor: "pointer",
              position: "relative",
              margin: "0",
              transition: "all 0.3s ease",
            }}
            className={` px-4 py-2 text-center hover-effect
      `}
            onClick={() => setActiveType(type?.id)}
          >
            {type?.name.charAt(0).toUpperCase() + type?.name.slice(1)}
          </p>
        ))}
      </div>

      {/* Scheduling Options */}
      <div className="status-inner-block mt-3 mb-4">
        {`Set Schedule For`}

        <div className="subscription-plan-list-element">
          <div className="">
            <div
              className="form-check form-check-inline custom-btn-radio"
              checked
              onChange=""
            >
              <Field
                type="radio"
                name="courtSchedulingFillingType"
                id="multipleDays"
                value="multipleDays"
                className="form-check-input"
                checked={courtSchedulingFillingType === "multipleDays"}
                onClick={(e) => {
                  setCourtSchedulingFillingType(e.target.value);
                }}
              />
              <label className="form-check-label label-blk" for="multipleDays">
                Multiple Days
              </label>
            </div>
          </div>
        </div>
        <div className="subscription-plan-list-element">
          <div className="">
            <div
              className="form-check form-check-inline custom-btn-radio"
              checked
              onChange=""
            >
              <Field
                type="radio"
                name="courtSchedulingFillingType"
                id="timeRange"
                value="timeRange"
                className="form-check-input"
                checked={courtSchedulingFillingType === "timeRange"}
                onClick={(e) => {
                  setCourtSchedulingFillingType(e.target.value);
                }}
              />
              <label
                className="form-check-label label-blk"
                for="timeRange"
              >
                Time Range & Interval
              </label>
            </div>
          </div>
        </div>
      </div>
      {courtSchedulingFillingType === "multipleDays" && (
        <>
          <div className="mt-5 mb-5">
            <Row>
              <Col md={4}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                  <Label for="multi-day-from">From</Label>
                  <Input
                    type="select"
                    name="multi-day-from"
                    id="multi-day-from"
                    value={tempTimeStateObject.start ?? ""}
                    key={`multi-day-from-${tempTimeStateObject.start}`}
                    placeholder="From"
                    onChange={(e) => {
                      const startValue = e.target.value;
                      setTempTimeStateObject((prevState) => ({
                        ...prevState,
                        start: startValue,
                      }));
                    }}
                  >
                    <option value="">Select Start Time</option>
                    {timesArr.map((time, index) => (
                      <option key={index} value={index}>
                        {time.time}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                  <Label for="multi-day-to">To</Label>
                  <Input
                    type="select"
                    name="multi-day-to"
                    id="multi-day-to"
                    value={tempTimeStateObject.end ?? ""}
                    key={`multi-day-to-${tempTimeStateObject.end}`}
                    placeholder="To"
                    onChange={(e) => {
                      const endValue = e.target.value;
                      setTempTimeStateObject((prevState) => ({
                        ...prevState,
                        end: endValue,
                      }));
                    }}
                  >
                    <option value="">Select End Time</option>
                    {timesArr.map((time, index) => (
                      <option key={index} value={index}>
                        {time.time}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <button
                  onClick={handleAddTimeSlot}
                  disabled={isAddSlotButtonDisabled()}
                  type="button"
                  className="btn"
                >
                  Add Slot
                </button>
              </Col>
            </Row>
          </div>
        </>
      )}
      {courtSchedulingFillingType === "timeRange" && (
        <>
          <div className="mt-5 mb-5">
            <Row>
              <Col md={2}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                  <Label for="period-day-from">Start Period Time</Label>
                  <Input
                    type="select"
                    name="period-day-from"
                    id="period-day-from"
                    value={tempTimeStateObject.start ?? ""}
                    key={`period-day-from-${tempTimeStateObject.start}`}
                    placeholder="From"
                    onChange={(e) => {
                      const startValue = e.target.value;
                      setTempTimeStateObject((prevState) => ({
                        ...prevState,
                        start: startValue,
                      }));
                    }}
                  >
                    <option value="">Select Start Time</option>
                    {timesArr.map((time, index) => (
                      <option key={index} value={index}>
                        {time.time}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                  <Label for="period-day-to">End Period Time</Label>
                  <Input
                    type="select"
                    name="period-day-to"
                    id="period-day-to"
                    value={tempTimeStateObject.end ?? ""}
                    key={`period-day-to-${tempTimeStateObject.end}`}
                    placeholder="To"
                    onChange={(e) => {
                      const endValue = e.target.value;
                      setTempTimeStateObject((prevState) => ({
                        ...prevState,
                        end: endValue,
                      }));
                    }}
                  >
                    <option value="">Select End Time</option>
                    {timesArr.map((time, index) => (
                      <option key={index} value={index}>
                        {time.time}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                <MultiSelector
                    name="durationsSelected"
                    placeholder="Intervals (in minutes)"
                    data={durationsList}
                    handleChange={formikProps.setFieldValue}
                    selected={durationsSelected}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                  <Label for="step-minutes">New Slot Every (optional)</Label>
                  <Input
                    type="select"
                    name="step-minutes"
                    id="step-minutes"
                    value={stepMinutes ?? ""}
                    onChange={(e) => setStepMinutes(e.target.value ? parseInt(e.target.value, 10) : null)}
                  >
                    <option value="">Default (same as duration)</option>
                    <option value="15">Every 15 min</option>
                    <option value="20">Every 20 min</option>
                    <option value="30">Every 30 min</option>
                    <option value="45">Every 45 min</option>
                    <option value="60">Every 60 min</option>
                  </Input>
                  <FormText>
                    If left empty, slots follow one after another (no overlapping).  
                    Example: With 60-min duration and “New Slot Every 30 min” → slots overlap.
                  </FormText>
                </FormGroup>
              </Col> 
              <Col md={2}>
                <button
                  onClick={generateStartTimeAndEndByIntervalPeriod}
                  disabled={isAddSlotButtonDisabled()}
                  type="button"
                  className="btn"
                >
                  Add Slots
                </button>
              </Col>
            </Row>
          </div>
        </>
      )}
      {!edit && (
        <FormGroup className="schedule-checkboxes-list col-1" check>
          <Label check className="container-blk">
            <Input
              type="checkbox"
              id="allDays"
              onChange={(e) => {
                setAllDaysCheckedByType({
                  ...allDaysCheckedByType,
                  [activeType]: e.target.checked,
                });

                if (e.target.checked) {
                  setCheckedDaysByType({
                    ...checkedDaysByType,
                    [activeType]: {
                      Saturday: true,
                      Sunday: true,
                      Monday: true,
                      Tuesday: true,
                      Wednesday: true,
                      Thursday: true,
                      Friday: true,
                    },
                  });
                } else {
                  //reset days and times
                  resetDaysAndTimes();
                }
              }}
              checked={
                allDaysCheckedByType ? allDaysCheckedByType[activeType] : false
              }
            />
            All Days
            <span className="checkmark"></span>
          </Label>
        </FormGroup>
      )}

      {console.log({ values, dayTimeStateByType })}
      <ul className="schedule-checkbox-list-block mt-2">
        {weekDays.map((value, index) => {
          const times = dayTimeStateByType
            ? dayTimeStateByType[activeType]
            : [];
          const days = checkedDaysByType ? checkedDaysByType[activeType] : {};
          return (
            <Row
              className={`schedule-row ${value.name}`}
              style={{
                backgroundColor: value.id % 2 === 0 ? "#f5f7f8" : "",
              }}
            >
              <li className="schedule-checkbox-element">
                <FormGroup className="schedule-checkboxes-list" check>
                  <Label check className="container-blk">
                    <Input
                      type="checkbox"
                      id={value.id}
                      onChange={(e) => {
                        if (e.target.checked) {
                          days[`${value.name}`] = true;
                        } else {
                          setAllDaysCheckedByType({ [activeType]: false });
                          days[`${value.name}`] = false;
                          // times[`${value.name}`] = [];
                        }
                        setCheckedDays({ [activeType]: days });
                        // formikProps.setDayTimeState(times);

                        // setFieldValue("scheduleDays", values.scheduleDays);
                        // setFieldValue("scheduleDaysByType", {...values.scheduleDays:[activeType]});
                      }}
                      checked={days ? days[`${value.name}`] : false}
                    />{" "}
                    {value.name}
                    <span className="checkmark"></span>
                  </Label>
                </FormGroup>
                <span
                  className="selected-times-outer-container"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2,0.1fr)",
                  }}
                >
                  {dayTimeStateByType && dayTimeStateByType[activeType] && (
                    <span className="selected-times-container ">
                      {dayTimeStateByType[activeType][`${value.name}`]?.map(
                        (time, timeIndex) => {
                          return (
                            <span className="time-card-container">
                              <span className="time-card-inner-container">
                                <span className="time-card-texts">
                                  {time.start} - {time.end}
                                </span>
                                <span
                                  className="times-card-delete"
                                  onClick={() => {
                                    setDeleteTimeState({
                                      day: value.name,
                                      timeIndex: timeIndex,
                                    });
                                  }}
                                >
                                  <img src={deletenew} />
                                </span>
                              </span>
                            </span>
                          );
                        }
                      )}
                      {/* {courtSchedulingFillingType === "dayByDay" &&
                        days[`${value.name}`] && (
                          <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                            <Input
                              type="select"
                              className={` times-dropdown time-from `}
                              name={`times-${value.name}-from`}
                              id={`${value.name}-times`}
                              value={
                                tempTimeStateObject.day === value.name
                                  ? tempTimeStateObject.start
                                  : ""
                              }
                              placeholder={"Court"}
                              onChange={(e) => {
                                setTempTimeStateObject({
                                  ...tempTimeStateObject,
                                  start: e.target.value,
                                  day: `${value.name}`,
                                });
                                setChanger(!changer);
                              }}
                            >
                              <option value="">From</option>
                              {tempTimeStateObject.end
                                ? timesArr
                                    .slice(0, tempTimeStateObject.end)
                                    .map((time, timeIndex) => {
                                      return (
                                        <option
                                          key={time.value}
                                          value={timesArr.indexOf(time)}
                                        >
                                          {time.time}
                                        </option>
                                      );
                                    })
                                : timesArr.map((time, timeIndex) => {
                                    return (
                                      <option
                                        key={time.value}
                                        value={timeIndex}
                                      >
                                        {time.time}
                                      </option>
                                    );
                                  })}
                            </Input>
                            <Input
                              type="select"
                              placeholder="To"
                              className={`form-control times-dropdown time-to`}
                              name={`times-${value.name}-to`}
                              value={tempTimeStateObject.end}
                              id={`${value.name}-times `}
                              onChange={(e) => {
                                setTempTimeStateObject({
                                  ...tempTimeStateObject,
                                  end: e.target.value,
                                  day: `${value.name}`,
                                });
                                setChanger(!changer);
                              }}
                            >
                              <option value="">To</option>
                              {tempTimeStateObject.start
                                ? timesArr
                                    .slice(
                                      parseInt(tempTimeStateObject.start) + 1
                                    )
                                    .map((time, timeIndex) => {
                                      return (
                                        <option
                                          key={time.value}
                                          value={timesArr.indexOf(time)}
                                        >
                                          {time.time}
                                        </option>
                                      );
                                    })
                                : timesArr.map((time, timeIndex) => {
                                    return (
                                      <option
                                        key={time.value}
                                        value={timeIndex}
                                      >
                                        {time.time}
                                      </option>
                                    );
                                  })}
                            </Input>
                          </FormGroup>
                        )} */}
                    </span>
                  )}
                </span>
              </li>
            </Row>
          );
        })}
      </ul>
    </div>
  );
};

export default TypeScheduleTabs;
